'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    TheCityWidgetController.$inject = ['$q', 'municipalRoll'];
    angular.module('app.open-data').component('theCityWidget', {
        template: '<div class="panel dashboard-panel {{$ctrl.cssClass}}" translate-namespace="open-data.widgets.the-city"><div class="panel-heading"><h2 translate>.The City</h2></div><div class="panel-body"><p translate translate-values="{\'date\': $ctrl.municipalRoll[0].date, \'residents\': $ctrl.municipalRoll[0].residents, \'increase\': $ctrl.municipalRoll[0].residents - $ctrl.municipalRoll[1].residents, \'last_date\':$ctrl.municipalRoll[1].date }">.phrase:population</p><p translate translate-values="{\'voters\': $ctrl.municipalRoll[0].registered_voters}">.phrase:population-voters</p></div><div class="panel-footer"><div class="text-right"><a ui-sref="municipal-roll"><span translate>.see more</span></a></div></div></div>',
        controller: TheCityWidgetController,
        controllerAs: '$ctrl',
        bindings: {
            cssClass: '@'
        }
    });

    function TheCityWidgetController($q, municipalRoll) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $q.all({
                municipalRoll: municipalRoll.getLatestTwoEntries()
            }).then(function (rsp) {
                $ctrl.municipalRoll = rsp.municipalRoll;
            });
        };
        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};
    }
})();